<template>
	<div>
		<span v-if="viewModel.id > 0">
			<md-icon icon="home" v-if="viewModel.source == 'scadmin'" v-b-tooltip.hover v-b-tooltip.right :title="$t('tooltips.scadmin')"/>
			<b-badge variant="info" v-else v-b-tooltip.hover v-b-tooltip.right :title="$t('tooltips.be')">PV</b-badge>
			{{ this.$t('bookings.booking') }} #{{ viewModel.id }}
			<b-badge
				:variant="viewModel.status == 'active' ? 'success' : 'danger'"
				>{{ viewModelStatusLabel }}</b-badge
			>
		</span>
		<span v-else>
			{{this.$t('bookings.newRes')}}
		</span>
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	computed: {
		...mapState("reservation", ["viewModel"]),
		viewModelStatusLabel() {
			return this.$root.auxVars.reservationStatusOpts.find(
				aux => aux.value == this.viewModel.status
			).text;
		}
	},
	methods: {}
};
</script>

<style></style>
